import React from 'react';
import Modal from '.';

interface ConfirmModalProps {
	children?: React.ReactNode
	title?: string
	message?: string
	onConfirm: () => void
	onCancel: () => void
}

function ConfirmModal(props: ConfirmModalProps) {
	const ref = React.useRef<any>();

	return (
		<>
			{React.Children.map(props.children, (c) => !React.isValidElement(c) ? c : React.cloneElement(c, { ...c.props, onClick: () => ref.current?.open() }))}

			<Modal ref={ref}>
				<Modal.Header title={props.title ?? 'Tem certeza?'} hideCloseButton />
				<Modal.Body>
					<p>{props.message ?? ''}</p>
				</Modal.Body>

				<Modal.Footer>
					<button
						type="button"
						className="btn btn-outline-secondary"
						onClick={() => {
							ref.current?.close();
							props.onCancel?.();
						}}
					>
						Cancelar
					</button>

					<button
						type="button"
						className="btn btn-primary"
						onClick={() => {
							props.onConfirm?.();
							ref.current?.close();
						}}
					>
						Confirmar
					</button>
				</Modal.Footer>
			</Modal>
		</>
	);
}

ConfirmModal.displayName = 'ConfirmModal';

export default ConfirmModal;
